export class AppConstants {
  public static SESSION_TOKEN = "weekly-plan-authToken";
  public static USER = 'weekly-plan-user';
  public static ROLE = "weekly-plan-role";
  public static THEME = "weekly-plan-theme";
  public static LANGUAGE = "weekly-plan-language";
  public static SIDEBAR_COLLAPSED = "weekly-plan-sidebar-collapsed";
  public static IS_MOBILE = "isMobile";

  public static ADMIN = "admin";

  // "config" kept for legacy sessions / DBs that still use the old role name
  public static ADMIN_ROLES = ["admin", "config"];
  public static TEACHER_ROLE = "teacher";
  public static TEACHER_ROLES = ["teacher"];
  public static SUPERVISOR_ROLE = "supervisor";
  public static SUPERVISOR_ROLES = ["supervisor"];
}
